export const selectResumeTemplate = (state) => state.resumeTemplate;

export const selectToggleableJsonResume = (state) => state.toggleableJsonResume;
